/* ============================================================
 * STOOTH LP — small behaviours (no dependencies)
 *  - Marquee (STOOTH in Action): right → left, seamless loop, ~60px/s
 *    (reference site's linear autoplay slider ≈75px/s, slowed on request)
 *  - Back-to-top button (stops just above the footer)
 * ============================================================ */
(function () {
  /* ---------- Marquee ---------- */
  var SPEED = 60; // px per second (reference site ≈75; tuned on request: 75 → 50 → 60)
  var marquee = document.querySelector(".marquee");
  var track = marquee && marquee.querySelector(".marquee-track");
  var set = track && track.querySelector(".marquee-set");

  function buildMarquee() {
    if (!set) return;
    // remove previously added clones
    track.querySelectorAll(".marquee-set.clone").forEach(function (c) { c.remove(); });
    var setW = set.getBoundingClientRect().width;
    if (!setW) return;
    // enough copies so the strip is never empty while one set scrolls out
    var copies = Math.max(2, Math.ceil(window.innerWidth / setW) + 1);
    for (var i = 1; i < copies; i++) {
      var c = set.cloneNode(true);
      c.classList.add("clone");
      c.setAttribute("aria-hidden", "true");
      track.appendChild(c);
    }
    track.style.setProperty("--set-w", setW + "px");
    track.style.setProperty("--marquee-dur", (setW / SPEED) + "s");
  }

  if (set) {
    var imgs = set.querySelectorAll("img");
    var pending = imgs.length;
    imgs.forEach(function (img) {
      if (img.complete) { if (--pending === 0) buildMarquee(); }
      else img.addEventListener("load", function () { if (--pending === 0) buildMarquee(); });
      img.addEventListener("error", function () { if (--pending === 0) buildMarquee(); });
    });
    if (pending === 0) buildMarquee();
    var rt;
    window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(buildMarquee, 150); });
  }

  /* ---------- Back to top ---------- */
  var toTop = document.createElement("button");
  toTop.className = "to-top";
  toTop.type = "button";
  toTop.setAttribute("aria-label", "Back to top");
  toTop.innerHTML =
    '<svg width="20" height="14" viewBox="0 0 28 20" fill="none" aria-hidden="true">' +
    '<path d="M4 16 L14 4 L24 16" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  document.body.appendChild(toTop);

  toTop.addEventListener("click", function () {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  var footer = document.querySelector(".site-footer");

  function update() {
    var y = window.scrollY || document.documentElement.scrollTop;
    toTop.classList.toggle("show", y > 400);
    if (!footer) return;
    var mobile = window.innerWidth <= 820;
    var gap = mobile ? 16 : 28;
    var footerTop = footer.getBoundingClientRect().top + y;
    var viewportBottom = y + window.innerHeight;
    if (viewportBottom > footerTop) {
      toTop.style.position = "absolute";
      toTop.style.bottom = "auto";
      toTop.style.top = (footerTop - gap - toTop.offsetHeight) + "px";
    } else {
      toTop.style.position = "fixed";
      toTop.style.top = "auto";
      toTop.style.bottom = gap + "px";
    }
  }

  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  update();
})();
